export enum ESiteContext {
  Shop = 'shop',
  Cms = 'cms',
}
